import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {
  Typography,
  Drawer,
  Divider,
  Box,
  ListItemButton,
  ListItemIcon,
} from '@mui/material';
import About from './About';
import InfoIcon from '@mui/icons-material/Info';
import CustomDialog from '../ui/feedback/CustomDialog';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { getFromStorage } from '../../scripts/common/StorageHelper';
import { STORAGE_VERIFY_CONNECTION } from './Storage';

const Header = (props) => {
  const disableMenu = props.disableMenu ? props.disableMenu : false;
  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [openAboutDialog, setOpenAboutDialog] = useState(false);
  const [reCheck, setReCheck] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [disableCheck, setDisableCheck] = useState();
  const { t } = useTranslation();

    const resetCheckTrigger = useCallback(() => {
      setReCheck(false);
      const status = getFromStorage(STORAGE_VERIFY_CONNECTION);
      if (status) {
        setDisableCheck(true);
      }
    }, []);

    useEffect(() => {
      if (disableCheck === undefined) {
        //disable check connectivity if STORAGE_VERIFY_CONNECTION is already in sessionStorage
        resetCheckTrigger();
      }
    }, [disableCheck, resetCheckTrigger]);

  const toggleMenu = () => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setOpen(!open);
  };

  return (
    <React.Fragment>
      <AppBar
        position="absolute"
        sx={{
          backgroundColor: '#003d4d!important',
          zIndex: (theme) => theme.zIndex.drawer,
        }}
      >
        <Toolbar sx={{ pr: '24px' }}>
          {!disableMenu && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 1 }}
              onClick={toggleMenu(true)}
              tabIndex={4}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Box
            component="img"
            sx={{
              height: '35px',
              padding: '.5px',
              alignContent: 'start',
            }}
            alt={t('components.common.applicationLogo', { title: document.title })}
            src="/assets/student_app_logo.png"
          />
          <Box sx={{ flexGrow: 1 }} />
          {disableMenu && state && <Typography>{state.name}</Typography>}
        </Toolbar>
        {!disableMenu && (
        <Drawer open={open} onClose={toggleMenu(false)}>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ width: 200 }} role="presentation">
            <List>
              <ListItem disablePadding>
                <ListItemButton onClick={() => setOpenAboutDialog(true)}>
                  <ListItemIcon>
                    <InfoIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography variant="caption" textAlign="right">
                          {t('components.common.aboutApp')} {(document.htmlTitle && parse(document.htmlTitle)) || document.title}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItemButton>
              </ListItem>
            </List>
            <Divider />
          </Box>
        </Drawer>
        )}
      </AppBar>
      <CustomDialog
        open={openAboutDialog}
        dialogProps={{
          title:
            (document.htmlTitle && parse(document.htmlTitle)) || document.title,
          component: (
            <About
              triggerCheck={reCheck}
              resetCheckTrigger={resetCheckTrigger}
              isVerifying={isVerifying}
              setIsVerifying={setIsVerifying}
            />
          ),
          actions: [
            {
              label: t('common.checkConnectivity'),
              handle: () => {
                setReCheck(true);
              },
              disabled: disableCheck
            },
            {
              label: t('common.cancel'),
              handle: () => {
                setOpenAboutDialog(false);
              },
            },
          ],
        }}
      />
    </React.Fragment>
  );
};
export default Header;
